import axios from "axios";

// ================= PACKKY CONFIG =================
const packkyBaseUrl = "https://api2.packky.com";
const packkyUsername = "packky@gmail.com";
const packkyPassword = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";

const packkyToken = btoa(`${packkyUsername}:${packkyPassword}`);

// ================= ANLOOK CONFIG =================
const anlookBaseUrl = "https://api.anlook.com";
const anlookUsername = "anlook@gmail.com";
const anlookPassword = "Anlook@12345";

const anlookToken = btoa(`${anlookUsername}:${anlookPassword}`);

// ================= PACKKY AXIOS INSTANCE =================
export const packkyAxiosInstance = axios.create({
  baseURL: packkyBaseUrl,
  headers: {
    Authorization: `Basic ${packkyToken}`,
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

// ================= ANLOOK AXIOS INSTANCE =================
export const anlookAxiosInstance = axios.create({
  baseURL: anlookBaseUrl,
  headers: {
    Authorization: `Basic ${anlookToken}`,
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

// Existing imports ko break nahi karna ho to Packky default rakho
export default packkyAxiosInstance;
